/**
 * 自定义字段枚举与相关约束常量
 *
 * 前后端共享：后端用于字段定义校验与存储，前端用于动态表单渲染。
 * 详见 design.md §FieldType 枚举（置于 apps/shared，前后端共享）
 * Requirements: 2.2、3.1、7.1
 */

/** 自定义字段类型枚举（8 种） */
export enum FieldType {
  /** 单行文本 */
  TEXT = 'text',
  /** 多行文本 */
  TEXTAREA = 'textarea',
  /** 数字 */
  NUMBER = 'number',
  /** 金额 */
  MONEY = 'money',
  /** 日期 */
  DATE = 'date',
  /** 下拉单选 */
  SELECT = 'select',
  /** 下拉多选 */
  MULTISELECT = 'multiselect',
  /** 布尔开关 */
  BOOLEAN = 'boolean',
}

/** 自定义字段输入组件枚举 */
export enum FieldInputComponent {
  /** 按字段类型使用默认控件 */
  DEFAULT = 'default',
  /** 行政区划三级级联选择 */
  REGION_CASCADER = 'region-cascader',
  /** 组织树选择 */
  ORG_TREE_SELECT = 'org-tree-select',
  /** 平台选择 */
  PLATFORM_SELECT = 'platform-select',
}

/**
 * 参与列表筛选的字段类型（Q3）
 *
 * text / textarea 走模糊匹配；select / multiselect / boolean / number / money / date
 * 走对应类型筛选。
 */
export const FILTERABLE_FIELD_TYPES: readonly FieldType[] = [
  FieldType.TEXT,
  FieldType.TEXTAREA,
  FieldType.SELECT,
  FieldType.MULTISELECT,
  FieldType.BOOLEAN,
  FieldType.NUMBER,
  FieldType.MONEY,
  FieldType.DATE,
];

/** 单个实体类型（EntityType）允许定义的启用状态自定义字段数量上限（R3.1） */
export const CUSTOM_FIELD_LIMIT = 50;

/** 字段在桌面端业务表格中的默认列宽（像素） */
export const CUSTOM_FIELD_COLUMN_WIDTH_DEFAULT = 140;

/** 字段表格列允许设置的最小宽度（像素） */
export const CUSTOM_FIELD_COLUMN_WIDTH_MIN = 80;

/** 字段表格列允许设置的最大宽度（像素） */
export const CUSTOM_FIELD_COLUMN_WIDTH_MAX = 600;

/**
 * 选项字段在列表、详情中渲染标签时可使用的预设颜色。
 *
 * 使用 Ant Design Vue 的预设色而非任意 CSS 值，保证不同页面的标签表现一致。
 */
export const FIELD_OPTION_TAG_COLOR_VALUES = [
  'default',
  'pink',
  'red',
  'orange',
  'green',
  'cyan',
  'blue',
  'purple',
  'geekblue',
  'magenta',
  'volcano',
  'gold',
  'lime',
] as const;

export type FieldOptionTagColor = (typeof FIELD_OPTION_TAG_COLOR_VALUES)[number];
